'use client'

import { useTranslations } from 'next-intl'

import { ModelsNews } from '@/api/generated-api'

import NewsArticleBody from '../NewsArticleBody'
import S from './ArticleContent.module.scss'

interface ArticleContentProps {
  news: ModelsNews
}

const ArticleContent = ({ news }: ArticleContentProps) => {
  const t = useTranslations('news.detail')

  const content = news.content || news.short_description || ''

  return (
    <div className={S.articleContent}>
      <div className={S.contentWrapper}>
        {content ? (
          // Body rendering lives in NewsArticleBody — it resolves the
          // {{media:N}} macros against news.media_blocks; plain splitting on
          // blank lines would print the macros as text.
          <NewsArticleBody news={news} />
        ) : (
          <div className={S.paragraph}>
            <p className={S.paragraphText}>{t('noContent')}</p>
          </div>
        )}
      </div>
    </div>
  )
}

export default ArticleContent
